import React from 'react';
import PropTypes from 'prop-types';

import ExternalAuthAccountListItem from './AccountListItem';

const ExternalAuthAccountList = ({ accounts, ...props }) => (
  <ul className="external-auth-accounts">
    {accounts.map(account => (
      <ExternalAuthAccountListItem
        key={account.uuid}
        account={account}
        {...props}
      />
    ))}
  </ul>
);

ExternalAuthAccountList.propTypes = {
  accounts: PropTypes.array.isRequired,
};

export default ExternalAuthAccountList;
